import ApiService from '@/core/services/api.service';

// Action Types
export const FETCH_MANDATORY_COMPLETIONS = 'FETCH_MANDATORY_COMPLETIONS';
export const MARK_NOTICE_AS_READ = 'MARK_NOTICE_AS_READ';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_MANDATORY_DATA = 'SET_MANDATORY_DATA';
export const RESET_MANDATORY_DATA = 'RESET_MANDATORY_DATA';

// State
const state = {
  notices: [],
  assignments: [],
  isLoading: false,
  error: null,
  isMandatoryExists: false
};

// Getters
const getters = {
  [SET_LOADING]: (state) => state.isLoading,
  [SET_ERROR]: (state) => state.error,
  notices: (state) => state.notices,
  assignments: (state) => state.assignments,
  hasMandatoryItems: (state) => state.notices.length > 0 || state.assignments.length > 0,
};

// Mutations
const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.isLoading = payload;
  },
  [SET_ERROR]: (state, payload) => {
    state.error = payload;
  },
  [SET_MANDATORY_DATA]: (state, payload) => {
    state.notices = payload.notices || [];
    state.assignments = payload.assignments || [];
    state.isMandatoryExists = payload.is_mandatory_exists || false;
  },
  [RESET_MANDATORY_DATA]: (state) => {
    state.notices = [];
    state.assignments = [];
    state.isMandatoryExists = false;
    state.error = null;
  },
  [MARK_NOTICE_AS_READ]: (state, noticeId) => {
    const notice = state.notices.find(n => n.id === noticeId);
    if (notice) {
      notice.pivot.is_read = 1;
    }
  }
};

// Actions
const actions = {
  [FETCH_MANDATORY_COMPLETIONS]: async ({ commit }) => {
    try {
      commit(SET_LOADING, true);
      commit(SET_ERROR, null);
      
      const response = await ApiService.get('api/dashboard/mandatory-completions');
      const data = response.data;
      
      commit(SET_MANDATORY_DATA, data);
      
      return data;
    } catch (error) {
      console.error('Error fetching mandatory completions:', error);
      commit(SET_ERROR, error);
      throw error;
    } finally {
      commit(SET_LOADING, false);
    }
  },

  [MARK_NOTICE_AS_READ]: async ({ commit, state }, noticeId) => {
    try {
      await ApiService.post('api/notice-update', {
        notification_id: [noticeId]
      });
      
      // Local state'i güncelle
      commit(MARK_NOTICE_AS_READ, noticeId);
      
      return true;
    } catch (error) {
      console.error('Error marking notice as read:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
